import { NgModule, ErrorHandler, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';


import { IonicModule, IonicRouteStrategy } from '@ionic/angular';


import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';



// import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { DropdownModule } from 'primeng/dropdown';
import { ViacepProvider } from './shared/viacep';
import { ButtonModule } from 'primeng/button';
import { CurrencyMaskModule } from 'ng2-currency-mask';



import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';


import { HttpClientModule, HttpClient } from '@angular/common/http';

import { Printer, PrintOptions } from '@ionic-native/printer/ngx';

import { ClienteapiService } from 'src/app/dao/api_cliente.service';
import { GlobalService } from './dao/global.service';


import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt, 'pt-BR');


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  // tslint:disable-next-line: max-line-length
  imports: [MultiSelectModule,
    CurrencyMaskModule,
    InputNumberModule,
    ButtonModule,
    DropdownModule,
    HttpClientModule,
    ScrollingModule,
    NoopAnimationsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule],
  providers: [
    StatusBar,
    // Grande sacada para formatar numeros e datas no formato brasileiro
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    ClienteapiService,
    SplashScreen,
    Printer,
    ViacepProvider,
    GlobalService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
